var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7071_13341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 2.25H3.75C2.925 2.25 2.25 2.925 2.25 3.75V14.25C2.25 15.075 2.925 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V3.75C15.75 2.925 15.075 2.25 14.25 2.25ZM14.25 14.25H3.75V3.75H14.25V14.25Z",
    fill: "#7100FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 5.78906H4.6875V6.91406H8.4375V5.78906Z",
    fill: "#7100FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.8125H9.75V12.9375H13.5V11.8125Z",
    fill: "#7100FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.9375H9.75V11.0625H13.5V9.9375Z",
    fill: "#7100FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5H7.125V12H8.625V10.875H7.125V9.375H6V10.875H4.5V12H6V13.5Z",
    fill: "#7100FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5675 8.2125L11.625 7.155L12.6825 8.2125L13.4775 7.4175L12.42 6.3525L13.4775 5.295L12.6825 4.5L11.625 5.5575L10.5675 4.5L9.77246 5.295L10.83 6.3525L9.77246 7.4175L10.5675 8.2125Z",
    fill: "#7100FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7071_13341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalculator);
export default __webpack_public_path__ + "static/media/iconCalculator.76eabd06e32cafa01ad999bbcde7f8f3.svg";
export { ForwardRef as ReactComponent };